module.exports = __webpack_public_path__ + "static/media/pembukuan.992f0078.png";